import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { BucketCreatePage } from '@/features/data/buckets/bucket-create-page';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Déclarer un bucket S3 existant (porting README #68). */
export const Route = createFileRoute('/$tenant/buckets/new')({ component: BucketCreateRoute });

function BucketCreateRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="buckets"
      crumbs={[{ label: t('nav.items.buckets') }, { label: t('bucketManage.new') }]}
    >
      <BucketCreatePage tenantId={tenant} />
    </ConsoleShell>
  );
}
